import * as types from './mutationTypes';

export default {
  [types.SET_DISTRIBUTIONS](state, distributions) {
    state.distributions = distributions;
  },
  [types.CLEAR_DISTRIBUTIONS](state) {
    state.distributions = [];
  },
  [types.SET_DISTRIBUTION](state, { distribution }) {
    state.distribution = distribution;
  },
  [types.CLEAR_DISTRIBUTION](state) {
    state.distribution = {};
  },
  [types.SET_VALIDITY_AT](state, { validityAt }) {
    state.distribution.validity_at = validityAt;
  },
  [types.SET_SCHEDULE_AT](state, { scheduleAt }) {
    state.distribution.schedule_at = scheduleAt;
  },
  [types.SET_WHATSAPP_INTEGRATIONS](state, { integrations }) {
    state.whatsappIntegrations = integrations;
  },
  [types.CLEAR_WHATSAPP_INTEGRATIONS](state) {
    state.whatsappIntegrations = [];
  },
  [types.SET_REMINDER_AT](state, { reminderAt }) {
    state.distribution.reminder_at = reminderAt;
  },
  [types.SET_REMINDER_AT_FIELD](state, { field, value }) {
    state.reminderAtFields[field] = value;
  },
  [types.RESET_REMINDER_AT_FIELDS](state) {
    state.reminderAtFields = {
      days: 3,
      hours: null,
    };
  },
  [types.SET_QUERY_PARAMS](state, { queryParams }) {
    state.queryParams = {
      ...state.queryParams,
      ...queryParams,
    };
  },
  [types.CLEAR_QUERY_PARAMS](state) {
    state.queryParams = {};
  },
  [types.SET_WHATASTPP_INTEGRATION](state, { integrationUUID }) {
    state.distribution.whatsapp_integration_uuid = integrationUUID;
  },
  [types.SET_CHANNEL](state, { channel }) {
    state.distribution.distribution_channel = channel;
  },
  [types.SET_NAME](state, { name }) {
    state.distribution.name = name;
  },
  [types.SET_IS_ANONYMOUS](state, { isAnonymous }) {
    state.distribution.is_anonymous = isAnonymous;
  },
  [types.SET_WHATSAPP_TEMPLATES](state, { whatsappTemplate }) {
    state.distribution.whatsapp_template = whatsappTemplate;
  },
  [types.SET_MAPPING](state, { mapping }) {
    state.distribution.mapping = mapping;
  },
  [types.SET_IMPORT_INVALID_LINES](state, { importInvalidLines }) {
    state.distribution.import_invalid_lines = importInvalidLines;
  },
  [types.SET_DELIMITER](state, { delimiter }) {
    state.distribution.delimiter = delimiter;
  },
  [types.SET_CUSTOMER_SIZE](state, { customerSize }) {
    state.distribution = {
      ...state.distribution,
      customers_size: customerSize,
    };
  },
  [types.SET_FILE](state, { file }) {
    state.distribution.file = file;
  },
  [types.SET_SCALE_LAYOUT](state, { scaleLayout }) {
    state.distribution.scale_layout = scaleLayout;
  },
  [types.SET_WHATSAPP_TEMPLATE_BODY](state, { body }) {
    state.distribution.whatsapp_template.body = body;
  },
  [types.SET_WHATSAPP_TEMPLATE_NAME](state, { name }) {
    state.distribution.whatsapp_template.name = name;
  },
  [types.SET_WHATSAPP_TEMPLATE_LANGUAGE](state, { language }) {
    state.distribution.whatsapp_template.language = language;
  },
  [types.SET_WHATSAPP_TEMPLATE_VARIABLES](state, { variables }) {
    state.distribution.whatsapp_template.variables = variables;
  },
  [types.SET_WHATSAPP_TEMPLATE_SCREEN_VARIABLES](state, { variables }) {
    state.whatsapp_template_screen_variables = variables;
  },
  [types.SET_WHATSAPP_REMINDER_TEMPLATE_BODY](state, { body }) {
    state.distribution.whatsapp_reminder_template.body = body;
  },
  [types.SET_WHATSAPP_REMINDER_TEMPLATE_NAME](state, { name }) {
    state.distribution.whatsapp_reminder_template.name = name;
  },
  [types.SET_WHATSAPP_REMINDER_TEMPLATE_LANGUAGE](state, { language }) {
    state.distribution.whatsapp_reminder_template.language = language;
  },
  [types.SET_WHATSAPP_REMINDER_TEMPLATE_VARIABLES](state, { variables }) {
    state.distribution.whatsapp_reminder_template.variables = variables;
  },
  [types.SET_WHATSAPP_REMINDER_TEMPLATE_SCREEN_VARIABLES](state, { variables }) {
    state.whatsapp_reminder_template_screen_variables = variables;
  },
  [types.SET_DISTRIBUTION_CUSTOMERS](state, { distributionCustomers }) {
    state.distributionCustomers = distributionCustomers;
  },
  [types.CLEAR_DISTRIBUTION_CUSTOMERS](state) {
    state.distributionCustomers = [];
  },
  [types.SET_DISTRIBUTION_IMPORT_CONFIRMED](state, import_confirmed) {
    state.distribution.import_confirmed = import_confirmed;
  },
  [types.SET_DISTRIBUTION_IMPORTED](state, imported) {
    state.distribution.imported = imported;
  },
  [types.SET_TOTAL_DISTRIBUTION_CUSTOMERS](state, { total }) {
    state.totalDistributionCustomers = total;
  },
  [types.CLEAR_TOTAL_DISTRIBUTION_CUSTOMERS](state) {
    state.totalDistributionCustomers = 0;
  },
  [types.TOGGLE_PREVIEW](state) {
    state.isPreviewOpen = !state.isPreviewOpen;
  },
  [types.SET_MESSAGE_TEMPLATE]: (state, { templateType, templateHash, getters }) => {
    const templateKey = getters.getTemplateKeyByType(templateType);
    state.distribution[templateKey] = templateHash;
  },
  [types.SET_LANGUAGE](state, language) {
    state.distribution.language = language;
  },
};
